import fontawesome from "@fortawesome/fontawesome";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import {
    faMapMarkerAlt,
    faEnvelope,
    faPhone,
    faBars,
    faChevronUp,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faArrowLeft,
    faArrowRight
} from "@fortawesome/fontawesome-free-solid";

import { faCircle } from "@fortawesome/fontawesome-free-regular";

import {
    faFacebookF,
    faLinkedinIn,
    faTwitter
} from "@fortawesome/fontawesome-free-brands";

fontawesome.library.add(
    faMapMarkerAlt,
    faEnvelope,
    faPhone,
    faCircle,
    faBars,
    faFacebookF,
    faLinkedinIn,
    faTwitter,
    faChevronUp,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faArrowLeft,
    faArrowRight
);



// WEBPACK FOOTER //
// ./src/theme/font-awesome-setup.js